function coerceArray(value) {
  return Array.isArray(value) ? value : [value];
}
export { coerceArray };
